const initialState = {
  isFetching: false,
  transactionNumber: null,
};

export default function stock(state = initialState, action) {
  switch (action.type) {
    case "PURCHASE_REQUESTED":
      return Object.assign({}, state, {
        isFetching: true,
        transactionNumber: null,
      });
    case "PURCHASE_CONFIRMED":
      return Object.assign({}, state, {
        isFetching: false,
        transactionNumber: action.data.transactionNumber,
      });
    default:
      return state;
  }
}
